import Banner from '@ben/orion/banner';
import Button from '@ben/orion/button';
import { Group, Stack } from '@mantine/core';
import { StartRunModal } from './start-run-modal';
import { useGroupDetail } from './use-group-detail';

/**
 * Start-run button + error feedback.
 * Co-locates `StartRunModal` so both share the same `useStartRun` instance —
 * modal choice state never needs to cross a component boundary.
 */
export const RunActions = () => {
  const { group, startRun, onStartUpdate, onStartBuild } = useGroupDetail();
  if (!group) return null;

  return (
    <Stack gap="sm">
      <Group>
        {/* Only one operation is valid at a time: _validate_scope rejects
            UPDATE without a linked benefit and CREATE with one. */}
        {group.benefit ? (
          <Button onClick={onStartUpdate} disabled={startRun.isStarting}>
            Start update run
          </Button>
        ) : (
          <Button onClick={onStartBuild} disabled={startRun.isStarting}>
            Start build run
          </Button>
        )}
      </Group>

      {startRun.error ? (
        <Banner variant="critical" message={startRun.error} />
      ) : null}

      <StartRunModal
        choice={startRun.choice}
        onConfirm={startRun.confirmChoice}
        onClose={startRun.cancelChoice}
        isStarting={startRun.isStarting}
      />
    </Stack>
  );
};
